import React from "react";
import { Modal, notification, Form, Input, Row, Col, Divider, Switch } from "antd";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { engGql } from "../../graphql/engagement";
import { defaultFormLayout, Utils } from "../../common/Utils";
import { GradePicker } from "../../components/GradePicker";
import { ActivityTypeSelect } from "./components/ActivityTypeSelect";
import { ActivityGoalsInput } from "./components/ActivityGoalsInput";
import { OrgGql } from "../../graphql/organization";

export const ToolActivityDlg = ({ onClose, model }) => {
  const [form] = Form.useForm();
  const [saveEngToolActivity, { loading: saving }] = useMutation(engGql.saveEngToolActivity);
  const { data: { gradeList } = { gradeList: [] } } = useQuery<{ gradeList: string[] }>(OrgGql.gradeList);

  const save = () => {
    form.validateFields().then((values) => {
      const { id } = model;
      const goalsItems = values.goalsItems.map(({ title, items }) => ({ title, items }));
      saveEngToolActivity({
        variables: { input: { id, ...values, goalsItems } },
      })
        .then((res) => {
          notification.success({ message: `activity saved` });
          onClose(true);
        })
        .catch((err) => {});
    });
  };

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const updateGoalsItems = () => {
    const isAll = form.getFieldValue("goalsGradeAll");
    if (isAll) {
      form.setFieldsValue({ goalsItems: [{ title: "Default", items: [""] }] });
    } else {
      let grades = form.getFieldValue("grades");
      if (grades.length === 0) {
        grades = gradeList;
      }
      form.setFieldsValue({ goalsItems: grades.map((g) => ({ title: g, items: [""] })) });
    }
  };
  const onValuesChange = (values) => {
    if (Utils.hasKey(values, "goalsGradeAll")) {
      updateGoalsItems();
    } else if (Utils.hasKey(values, "grades")) {
      updateGoalsItems();
    }
  };

  return (
    <Modal
      title="Engagement Activity"
      visible={true}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => onClose()}
      width={"90%"}
    >
      <Form
        {...defaultFormLayout}
        form={form}
        onValuesChange={onValuesChange}
        initialValues={{
          goalsGradeAll: true,
          ...model,
          grades: model.grades || [],
          goalsItems: model.goalsItems || [{ title: "Default", items: [""] }],
        }}
        size="small"
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="activityType"
              label="Activity Type"
              rules={[{ required: true, message: "Please select activity type" }]}
            >
              <ActivityTypeSelect />
            </Form.Item>
            <Form.Item
              name="activityName"
              label="Activity Name"
              rules={[{ required: true, message: "Please enter activity name" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Grade Range" name="grades">
              <GradePicker />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description Language"
              rules={[{ required: true, message: "Please enter description" }]}
            >
              <Input.TextArea />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              name="parentHelp"
              label="How can parents help?"
              rules={[{ required: true, message: "Please enter how can parents help" }]}
            >
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>

        <Divider>Goals</Divider>

        <h4>Set by Teacher</h4>
        <Form.Item {...layout} label="Description" name="goalsTeacher">
          <Input.TextArea />
        </Form.Item>
        <Form.Item {...layout} label="Are all grades the same?" name="goalsGradeAll" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item {...layout} label="Items" name="goalsItems">
          <ActivityGoalsInput />
        </Form.Item>
      </Form>
    </Modal>
  );
};
